import styled from "styled-components";

export const Title = styled.h3`
  font-family: "DM Sans";
  font-size: 22px;
  font-weight: 700;
  text-align: left;
`;

export const InputTitle = styled.input`
  width: 100%;
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  margin-bottom: 5px;
  height: 40px;
  border: none;
  color: black;
  padding: 10px;
  border-bottom: 1px solid black;
  &:focus {
    border-bottom: 1px solid black;
    /* border: none;  */
    outline: none;
  }
`;

export const Label = styled.label`
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 300;
  line-height: 19px;
  margin-bottom: 5px;
`;
